import React from 'react'

import Select from 'Components/Select'
import Input from 'Components/Input'
import Grid from '@material-ui/core/Grid'
import Title from 'Components/Title'

export default React.memo(props => <Title inline={props.inline} style={{ padding: '5px 0' }}
                                          title={props.title}
                                          buttons={(props.comboMultipleOption(props.options)).length > 0 && !props.disabled &&
                                          <button type="button" onClick={props.onClickAddComboMultiEntier}
                                                  className="text-success ei-commun_ajouter"
                                                  style={{ display: 'inline-block', marginLeft: 5 }}/>}>
  {
    (props.data !== undefined ? props.data : []).map((data, index) => (
      <Grid container style={{ margin: 0, padding: 0 }} spacing={0} justify={'center'}
            alignItems={'center'}>
        {!props.disabled && <Grid item style={{ margin: 0, padding: 0 }}>
          <button type="button" onClick={() => props.onClickRemoveComboMultiEntier(index)}
                  className="text-danger ei-commun_enlever"
                  disabled={props.disabled || false}/>
        </Grid>}
        <Grid item xs style={{ margin: 0, padding: 0 }}>
          <Select style={props.style}
                  disabled={props.disabled || false}
                  options={props.comboMultipleOption(props.options, data.id)}
                  onChange={props.onChangeComboMultiEntier}
                  name={index}
                  value={data.id}/>
        </Grid>
        <Grid item xs style={{ margin: 0, padding: 0 }}>
          <Input
            type='number' style={{ width: '100%' }}
            disabled={props.disabled || false}
            onChange={(e) => props.onChangeInputComboMultiEntier(e, index)}
            value={data.valeur_entier}/>
        </Grid>
      </Grid>
    ))
  }
</Title>)



// WEBPACK FOOTER //
// ./app/Utilitaire/Component/DataComponent/Components/ComboMultiEntier.js